<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template #activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <p v-if="label" class="input-title px-1 pb-1">{{ label }}</p>
        <v-text-field
          :value="displayValue"
          readonly
          outlined
          dense
          clearable
          :placeholder="placeholder"
          :rules="rules"
        />
      </div>
    </template>

    <v-date-picker
      v-model="internalDate"
      :min="minDate"
      :max="maxDate"
      no-title
      @input="menu = false"
    />
  </v-menu>
</template>

<script>
import dayjs from 'dayjs';
import i18n from '@/i18n';

export default {
  name: 'CfsDateInputComponent',

  props: {
    value: {
      type: String,
      default: null, // YYYY-MM-DD
    },
    label: {
      type: String,
      default: i18n.t('Date'),
    },
    placeholder: {
      type: String,
      default: i18n.t('SelectDate'),
    },
    minDate: {
      type: String,
      default: undefined, // YYYY-MM-DD
    },
    maxDate: {
      type: String,
      default: undefined, // YYYY-MM-DD
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      menu: false,
      internalDate: this.value, // YYYY-MM-DD
    };
  },
  computed: {
    displayValue() {
      return this.internalDate
        ? dayjs.utc(this.internalDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
        : '';
    },
  },
  watch: {
    value(val) {
      this.internalDate = val;
    },
    internalDate(val) {
      this.$emit('input', val);
    },
  },
};
</script>
